import api from '@/api'

const { $student, $core } = api;

export const { $processings } = $core;
export const { $students, $studentProcessing, $studentByIdentification, $generateDuesAccount, $studentContractPendingValidation } = $student;
